import { MuWidget } from "mu-widget/lib/MuWidget";

type ListItem = {
	value: string,
	text: string
};

export class MOSelect extends MuWidget
{
	updateUnselected() {
		throw new Error("Method not implemented.");
	}
	/**
	 *
	 */
	constructor(container : HTMLElement) {
		super();
		container.innerHTML += 
		'<div class="selected">' +
		'	<div mu-id="selected">' +
		'		<span mu-template="itemSelected" mu-widget="MOSelectItemSelected">' +
		'			<span class="item-selected">' +
		'				<span mu-id="text"></span>' +
		'				<span mu-id="remove" class="remove">&times;</span>' +
		'			</span>' +
		'		</span>' +
		'	</div>' +
		'</div>' +
		'<div mu-id="itemsContainer" class="items-container" >' +
		'	<div mu-id="items" class="items">' +
		'		<span class="item-new" mu-template="itemNew" mu-widget="MOSelectItem">' +
		'			<span mu-id="add" class="add">' +
		'				<span mu-id="text"></span>' +
		'				+' +
		'			</span>' +
		'		</span>' +
		'	</div>' +
		'</div>';
		container.className += " moselect";
		if (container.tabIndex == -1) container.tabIndex = 0;		
	}
	
	public items : ListItem[];
	private itemsByValue : Record<string, ListItem>;

	public afterIndex()
	{
		// Vybrané 
		/* var values = this.ui.value.value;
		if (values) values = JSON.parse(values);
		
		for(const item of this.items)
		{
			this.muWidgetFromTemplate("itemNew", this.ui.items, item);
	
			if (values && values.indexOf(item.value) > -1) this.addSelected(item);
		} */
		this.bindItems();
	}

	private bindItems() {
		this.itemsByValue = {};
		for(const item of this.items)
		{
			this.muWidgetFromTemplate("itemNew", this.ui.items, { listItem: item });
			this.itemsByValue[item.value] = item;
		}
	}

	public addSelected(listItem : ListItem, doUpdate : boolean = true)
	{
		this.muWidgetFromTemplate("itemSelected", this.ui.selected, { listItem: listItem });
		if (doUpdate) this.update();
	}

	public getSelectedValues() : string[]
	{
		return this.muGetChildWidgets<MOSelectItemSelected>("selected").map(item => item.listItem.value);
	}

	public setSelectedValues(values : string[]) : void {
		this.ui.selected.innerHTML = "";
		for(const value of values || []) this.addSelected(this.itemsByValue[value]);
	}

	public update() : void {
		var values = this.getSelectedValues();
		this.muGetChildWidgets<MOSelectItem>("items").map(
			moi => this.muVisible(values.indexOf(moi.listItem.value) < 0, moi.container)
		)
	}

	override muFetchData() {
		return this.getSelectedValues();
	}

	override muBindData(values: string[]) {
		this.setSelectedValues(values);
	}
	/* updateSelected: function()
	{
		var selectedValues = this.getSelectedValues();
		MuWidget.getChildWidgets(this.ui.items, function(item) {
			item.container.style.display = selectedValues.indexOf(item.value) > -1
				? "none"
				: null;
		});
		$(this.ui.selected).sortable({
			stop: this.muGetMethodCallback("updateValueField")
		});
		this.updateValueField(selectedValues);
	},
	updateValueField: function(selectedValues)
	{
		if (!Array.isArray(selectedValues)) selectedValues = this.getSelectedValues();
		this.ui.value.value = JSON.stringify(selectedValues);
	} */
}

export class MOSelectItemSelected extends MuWidget {
	public listItem : ListItem;

	public afterIndex()
	{
		this.ui.text.innerText = this.listItem.text;
	}
	
	public remove_click()
	{
		this.muRemoveSelf();
		(this.muParent as unknown as MOSelect).update();
	}
};

export class MOSelectItem extends MuWidget {
	public listItem : ListItem;

	public afterIndex()
	{
		this.ui.text.innerText = this.listItem.text;
	}

	public add_click()
	{
		(this.muParent as unknown as MOSelect).addSelected(this.listItem);
	}
};